import { composeIO } from 'react-compose-io'
import { itemListaRegularizacaoIO } from './ItemListaRegularizacao.IO'
import { ItemListaRegularizacaoView } from './ItemListaRegularizacao.View'

export const ItemListaRegularizacao = composeIO(ItemListaRegularizacaoView, itemListaRegularizacaoIO)
